<template>
  <div>
    <form
      ref="paymentForm"
      :action="url"
      class="paymentWidgets"
      :data-brands="dataBrands"
      v-bind="$attrs"
    />
  </div>
</template>
<script>
import axios from "axios";
export default {
  name: "CNPForm",
  props: {
    url: { type: String, default: null },
    entityId: {type: String, default: ''},
    currency: {type: String, default: ''},
    card: { type: String, default: null },
    client: { type: Object, default: null },
    dataBrands: { type: String, default: "VISA MASTER AMEX" },
  },
  data() {
    return {
      checkoutId: null,
      wpwlOptionsScript: null,
      wpwlScriptFilename: "js/wpwl-cnp-register.js",
    };
  },
  methods: {
    async createCheckout() {
      try {
        const response = await axios({
          method: "post",
          url: "register-card-cnp-live",
          data: {
            entityId: this.entityId,
            client: this.client,
            userId: this.$store.state.user.id,
            card: this.card,
            currency: this.currency,
          },
          config: {
            headers: { "Content-Type": "application/x-www-form-urlencoded" },
          },
        });

        // attach wpwl scripts
        this.wpwlOptionsScript = document.createElement("script");
        this.wpwlOptionsScript.setAttribute(
          "src",
          `${process.env.BASE_URL}${this.wpwlScriptFilename}`
        );
        document.head.appendChild(this.wpwlOptionsScript);

        const cnpScript = document.createElement("script");
        this.checkoutId = response.data.id;

        cnpScript.setAttribute(
          "src",
          `https://eu-prod.oppwa.com/v1/paymentWidgets.js?checkoutId=${this.checkoutId}`
        );
        document.head.appendChild(cnpScript);
      } catch (error) {
        this.errors.push(error);
      }
    },
    async clearCheckout() {
      return new Promise((res, rej) => {
        // clear scripts
        if (!window.wpwl || !window.wpwl.unload) rej();
        window.wpwl.unload();
        let scripts = document.querySelectorAll("script");
        for (let script of scripts) {
          if (
            script.src.indexOf("static.min.js") !== -1 ||
            script.src.indexOf(this.wpwlScriptFilename)
          )
            document.head.removeChild(script);
        }
        res();
      });
    },
  },
  beforeMount() {
    this.createCheckout();
  },
  async beforeDestroy() {
    await this.clearCheckout();
  },
};
</script>
